<template>
  <el-form-item :prop="prop" class="formItem" :style="borderBottom?'border-bottom:1px solid var(--border-soft, #E8E4DE)':''"
                :rules="rules">
    <div class="label">
      <span></span>
      {{ label }}
      <div class="question">
        <slot name="question"></slot>
      </div>
    </div>
    <slot name="content"></slot>
    <div class="tip" v-if="$slots.tip">
      <slot name="tip"></slot>
    </div>
    <div class="coupon" v-if="$slots.coupon">
      <slot name="coupon"></slot>
    </div>
  </el-form-item>
</template>

<script>
export default {
  name: "formItem",
  props: {
    prop: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    borderBottom: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: null
    }
  }
}
</script>

<style lang="less" scoped>
.formItem {
  margin: 0 63px 0 23px;
  padding: 30px 0;

  .label {
    display: flex;
    align-items: center;
    font-size: 20px;
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: 500;
    text-align: LEFT;
    color: var(--text-main, #111827);

    span {
      display: inline-block;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: var(--primary, #FF5A1F);
      margin: 0 11px 0 0;
    }

  }

  .tip {
    margin: 10px 0 0;
    width: max-content;
    padding: 7px 20px;
    display: flex;
    flex-direction: column;
    // align-items: center;
    justify-content: center;
    background: var(--warning-soft, #FFFBEB);
    border: 1px solid rgba(245, 158, 11, 0.2);
    font-size: 16px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    color: var(--text-secondary, #5A5F6B);
    line-height: 16px;
  }
  .coupon {
    margin: 10px 0 0;
    width: max-content;
    padding: 7px 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    color: var(--text-secondary, #5A5F6B);
    line-height: 16px;
    height: 200px;
    margin-left: 310px;
  }

}

</style>
